import React from "react";
import './css/SliderStyle.css';
import slider1 from './images/vigyan-vriksh-slider1.png';
import slider2 from './images/vigyan-vriksh-slider2.png';
import slider3 from './images/vigyan-vriksh-slider3.png';
import slider4 from './images/vigyan-vriksh-slider4.png';
import slider5 from './images/vigyan-vriksh-slider5.png';


function Slider() {
    return (
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators vertical-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button> */}
            </div>
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img src={slider1} className="d-block sliderimg" alt="Slide 1" />
                    <div className="carousel-caption">
                        {/* <h2>Knowledge At <span className="highlight">Your Fingertips</span></h2>
                        <p>Enim nec consectetur condimentum fermentum...</p>
                        <div className="features">
                            <div className="feature-item"><i className="bi bi-hand-thumbs-up"></i> Super easy to use</div>
                            <div className="feature-item"><i className="bi bi-pencil-square"></i> SEO - optimized</div>
                        </div>
                        <div className="buttons">
                            <button className="btn btn-custom-red">Free AI Assessment</button>
                            <button className="btn btn-custom-outline">Free Demo</button>
                        </div> */}
                    </div>
                </div>

                {/* <div className="carousel-item">
                    <img src={slider2} className="d-block w-100" alt="Slide 2" />
                    <div className="carousel-caption">
                        <h2>Knowledge At <span className="highlight">Your Fingertips</span></h2>
                        <p>Enim nec consectetur condimentum fermentum...</p>
                        <div className="features">
                            <div className="feature-item"><i className="bi bi-hand-thumbs-up"></i> Super easy to use</div>
                            <div className="feature-item"><i className="bi bi-pencil-square"></i> SEO - optimized</div>
                        </div>
                        <div className="buttons">
                            <button className="btn btn-custom-red">Free AI Assessment</button>
                            <button className="btn btn-custom-outline">Free Demo</button>
                        </div>
                    </div>
                </div> */}

                <div className="carousel-item">
                    <img src={slider4} className="d-block sliderimg" alt="Slide 2" />
                    <div className="carousel-caption">
                        {/* <h2>Knowledge At <span className="highlight">Your Fingertips</span></h2>
                        <p>Enim nec consectetur condimentum fermentum...</p>
                        <div className="features">
                            <div className="feature-item"><i className="bi bi-hand-thumbs-up"></i> Super easy to use</div>
                            <div className="feature-item"><i className="bi bi-pencil-square"></i> SEO - optimized</div>
                        </div>
                        <div className="buttons">
                            <button className="btn btn-custom-red">Free AI Assessment</button>
                            <button className="btn btn-custom-outline">Free Demo</button>
                        </div> */}
                    </div>
                </div>

                <div className="carousel-item">
                    <img src={slider3} className="d-block sliderimg" alt="Slide 3" />
                    <div className="carousel-caption">
                        {/* <h2>Knowledge At <span className="highlight">Your Fingertips</span></h2>
                        <p>Enim nec consectetur condimentum fermentum...</p>
                        <div className="features">
                            <div className="feature-item"><i className="bi bi-hand-thumbs-up"></i> Super easy to use</div>
                            <div className="feature-item"><i className="bi bi-pencil-square"></i> SEO - optimized</div>
                        </div>
                        <div className="buttons">
                            <button className="btn btn-custom-red">Free AI Assessment</button>
                            <button className="btn btn-custom-outline">Free Demo</button>
                        </div> */}
                    </div>
                </div>

                <div className="carousel-item">
                    <img src={slider5} className="d-block sliderimg" alt="Slide 4" />
                    <div className="carousel-caption">
                        {/* <h2>Knowledge At <span className="highlight">Your Fingertips</span></h2>
                        <p>Enim nec consectetur condimentum fermentum...</p>
                        <div className="features">
                            <div className="feature-item"><i className="bi bi-hand-thumbs-up"></i> Super easy to use</div>
                            <div className="feature-item"><i className="bi bi-pencil-square"></i> SEO - optimized</div>
                        </div>
                        <div className="buttons">
                            <button className="btn btn-custom-red">Free AI Assessment</button>
                            <button className="btn btn-custom-outline">Free Demo</button>
                        </div> */}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Slider;